import { render, staticRenderFns } from "./nbqEcharts.vue?vue&type=template&id=5b39cc8e&scoped=true&"
import script from "./nbqEcharts.vue?vue&type=script&lang=js&"
export * from "./nbqEcharts.vue?vue&type=script&lang=js&"
import style0 from "./nbqEcharts.vue?vue&type=style&index=0&id=5b39cc8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b39cc8e",
  null
  
)

component.options.__file = "nbqEcharts.vue"
export default component.exports